import { BOOKING_URL, CONTACTS_URL } from "../../services/common-urls";
import { JSON_STRING, HttpClient, MHTTPCL } from "../../services/http/http-client";
const INDIVIDUAL_CONTACT_FORM = 'individual_contact_form';

const ADD_COMPANY = 'add_company';
const SET_CONTACT_RELATIONS = 'set_contact_relations';
const SAVE_INDIVIDUAL_CONTACT_N_RETRIEVE_INDIVIDUAL_LIST = 'save_individual_contact_n_retrieve_individual_list';
const SEARCH_MODAL_CONTACTS = 'search_modal_contacts';

const BOTH_STRING = 'both';




const EMPTY_STRING = '';

export const ContactService = {
  findContactGroups: () => HttpClient.get(CONTACTS_URL, {
    action: INDIVIDUAL_CONTACT_FORM,
    makerelation: 1
  }),
  findContacts: ({
    searchString = EMPTY_STRING,
    contactSearchType = BOTH_STRING
  } = {}) => HttpClient.get(CONTACTS_URL, {
    action: SEARCH_MODAL_CONTACTS,
    search_str: searchString,
    contact_search_type: contactSearchType
  }),
  insertPerson: ({
    firstName,
    lastName,
    email,
    phone,
    group_id1,
    group_id2,
    group_id3,
  }) => HttpClient.post(CONTACTS_URL, {
    action: SAVE_INDIVIDUAL_CONTACT_N_RETRIEVE_INDIVIDUAL_LIST,
    first_name: firstName,
    last_name: lastName,
    email1: email,
    phone1: phone,
    group_id1,
    group_id2,
    group_id3,
  }),
  insertCompany: ({
    companyName,
    city,
    country,
    group_id1,
    group_id2,
    group_id3
  }) => HttpClient.get(CONTACTS_URL, {
    action: ADD_COMPANY,
    company_name: companyName,
    city,
    country,
    group_id1,
    group_id2,
    group_id3,
  }),
  insertContactRelation: ({
    contactId,
    externalId,
    externalId2,
    externalTable,
    externalTable2,
    templateType,
    contactSearchType = BOTH_STRING
  }) => HttpClient.post(CONTACTS_URL, {
    action: SET_CONTACT_RELATIONS,
    contact_id: contactId,
    external_id: externalId,
    external_table: externalTable,
    external_id2: externalId2,
    external_table2: externalTable2,
    template_type: templateType,
    contact_search_type: contactSearchType,
    output: JSON_STRING,
  }),

  deleteContactRelation: ({
    contactRelationId
  }) => HttpClient.post(CONTACTS_URL, {
    action: 'delete_relation',
    contact_relation_id: contactRelationId
  }),

  setItemContact: ({ table, key, kVal, name, contact_id, template_type, contact_search_type }) => MHTTPCL.post(CONTACTS_URL, {
    action: 'set_item_contact',
    table: table,
    key: key,
    kVal: kVal,
    name: name,
    value: contact_id,
    template_type: template_type,
    contact_search_type: contact_search_type,
    output: JSON_STRING
  }),
  checkCity: ({
    city = EMPTY_STRING,
  
  } = {}) => HttpClient.get(BOOKING_URL, {
    section: 'bookings',
    action: 'check_city',
    city,
   
  }),
  
}